<app-loader *ngIf="isLoading"></app-loader>
<div class="cab-form-wrapper">
  <!--  <app-button
      *ngIf="!this.createBookingService.isEditMode"
      class="clear-button"
      (clickCallback)="resetForm()"
      prefixIconSrc="assets/reset-circle.svg"
      type="primaryText"
      text="Clear All"
      size="tiny"
      ></app-button> -->
    <div class="basic-details">
      <ng-container *ngFor="let field of config">
        <ng-container *ngIf="checkVisibility(field.config, formDetails)">
          <div class="form-group" *ngIf="checkVisibility(field.config, formDetails)">
            <label class="form-label displayFlex" *ngIf="field.elementKey !== 'guardReq' || escortConfig.escortAssignment">{{field.config.displayName}}
              <span style="color: #B00020;" *ngIf="field.config.mandatory">*</span>
              <span *ngIf="field.elementKey == 'guardReq'" class="ml-8 marshallIcon"
              (mouseenter)="isHovered = true"
              (mouseleave)="isHovered = false"
              > <img src="assets/ic-action-info-24-grey.svg" alt="" style="width: 16px;">
              <ng-template [ngIf]="isHovered && tooltipContent.length">
                <span class="marshallInformation">
                  <ul>
                    <li *ngFor="let item of tooltipContent">{{ item }}</li>
                  </ul>
                </span>
              </ng-template>
            </span>
            </label>
            <div class="form-input">
              <ng-container [ngSwitch]="field.elementKey">
                <app-select
                  *ngSwitchCase="'city'"
                  [config]="field.config" 
                  [type]="'dropdownAndSearch'"
                  [formControl]="formDetails.get(field.elementKey)"
                  [hideOptions]="getHiddenOptions('city')"
                  [options]="field.config.values">
                </app-select>
                <app-select
                  *ngSwitchCase="'destinationCity'"
                  [showClear]="!field.config.mandatory"
                  [config]="field.config" [type]="formConstants.getElementType(field.config.elementType)"
                  [formControl]="formDetails.get(field.elementKey)"
                  [hideOptions]="getHiddenOptions('destinationCity')"
                  [options]="field.config.values">
                </app-select>
               
                <app-select
                  *ngSwitchCase="'vendor'"
                  [showClear]="!field.config.mandatory"
                  [config]="field.config" [type]="formConstants.getElementType(field.config.elementType)"
                  [formControl]="formDetails.get(field.elementKey)"
                  [getCustomOptionValue]="vendorList ? getVendorValue : null" 
                  [getCustomOptionLabel]="vendorList ? getVendorLabel : null"
                  [options]="vendorList || field.config.values">
                </app-select>
              <div *ngIf="!enableDesignationBasedVehicle; else showEnableDesignationBasedVehicle">
                <app-select *ngSwitchCase="'vehicleType'" [showClear]="!field.config.mandatory" [config]="field.config"
                  [type]="formConstants.getElementType(field.config.elementType)"
                  [formControl]="formDetails.get(field.elementKey)" [options]=" field.config.values">
                </app-select>
              </div>
              <ng-template #showEnableDesignationBasedVehicle>
                <ng-container *ngSwitchCase="'vehicleType'" >
                  <app-select  [showClear]="!field.config.mandatory" [config]="field.config"
                    [type]="formConstants.getElementType(field.config.elementType)"
                    [formControl]="formDetails.get(field.elementKey)" [options]="newRiderCabList['allocatedVehicle']" *ngIf="DesignationBasedVehicleAllocation!=='PERMISSIVE' && DesignationBasedVehicleAllocation!=='CAPACITIVE'">
                  </app-select>
                  <app-double-split-dropdown *ngIf="DesignationBasedVehicleAllocation==='PERMISSIVE'" [data]="newRiderCabList"
                    [formControls]="formDetails.get(field.elementKey)"></app-double-split-dropdown>
                  <app-double-split-dropdown *ngIf="DesignationBasedVehicleAllocation==='CAPACITIVE'" [data]="newRiderCabList"
                    [formControls]="formDetails.get(field.elementKey)" [eligibleVehicleLable]="'Designated Vehicle'" [OtherVehicle]="'High Capacity'" [showWarnigPopup]="false"></app-double-split-dropdown>
                </ng-container>
                
              </ng-template>
              <app-text-input *ngSwitchCase="'otherDetails'" [minlength]="minChar" [maxlength]="maxChar"
                [formControl]="formDetails.get(field.elementKey)">
              </app-text-input>
              <ng-container *ngSwitchCase="'guardReq'">
                <app-toggle-button
                *ngIf="escortConfig?.escortAssignment"
                [formControl]="formDetails.get(field.elementKey)"
                [isDisabled]="isEscortDisabled"
                >
                </app-toggle-button>
              </ng-container>
              
              <app-field-generator *ngSwitchDefault [config]="field.config" [maxlength]="maxChar"
                [inputControl]="formDetails.get(field.elementKey)">
              </app-field-generator>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </ng-container>
      <ng-template [ngIf]="marshallAllocated && toastTimer">
        <div class="cab-snackbar ">
            <span><img src="assets/ic-ui-info-24.svg"
                    alt="error"></span>
                    Dark hours travel, marshal automatically assigned.        </div>
    </ng-template>
  </div>
  <!-- ------------tabs---- -->
  <div class="days-tabs displayFlex" *ngIf="showSwitch && !dateEditable" >
    <app-tabs (tabChangeCallback)="onTabChange($event)" [tabs]="tabDetails" [initialState]="tabValue" [ngClass]="{'disableDropdown':editBooking && multidayUI}"></app-tabs>
    <span *ngIf="multidayUI" class="ml-24 displayFlex align-item-center">Total Days
      <span>
        <app-number-input [multiday]="multidayUI" (changeCallback)="getTotalDays($event)"></app-number-input>
      </span>
    </span>
  </div>
  <!-- <hr class="page-divider"> -->
  <ng-template #oneday>
   <div class="stop-list">
     <ng-container *ngFor="let stop of getStops(); let stopIndex = index">
        <div class="stop-wrapper">
          <div class="stop-form"  [ngClass]=" stopIndex==getStops().length-1 ? 'pt-16': ''">
            <ng-container *ngFor="let field of this.getFieldConfig(stopIndex)">
              <div class="field-column mb-16"
                [ngClass]="{'address': field.elementKey === 'address', 'time': field.elementKey === 'time'}"
                *ngIf="checkVisibility(field.config, stop) && field.config.elementType != 'button'">
                <div class="mb-10 color-181F33 " [ngClass]="field.elementKey=='address' ? 'font-weight-700 fs-14' : 'font-weight-400 fs-12'" [ngStyle]="field.elementKey=='riders'?{}:{'position':'relative'}">
                  <span class="address-icon" *ngIf="field.elementKey=='address' "> 
                    <img [src]="field.config.displayName=='Start Address'? 'assets/start_address.svg': field.config.displayName=='Stop'? 'assets/stop_address.svg ' : 'assets/end_address.svg' " alt="">
                  </span>
                  <span *ngIf="field.elementKey === 'time'; else otherDisplay">
                    <span *ngIf="enablePredictiveStopTime && stopIndex==0">
                      {{field.config.displayName}}
                      <span style="color: #B00020;" *ngIf="field.config.mandatory">*</span>
                    </span>
                    <span *ngIf="!enablePredictiveStopTime ">
                      {{field.config.displayName}}
                      <span style="color: #B00020;" *ngIf="field.config.mandatory">*</span>
                    </span>
                  </span>
                  <ng-template #otherDisplay>
                    <span>
                      {{field.config.displayName + (stopIndex > 0 && stopIndex < getStops().length -1 && field.elementKey=='address' ? ' ' +stopIndex : '' )}}
                      <span style="color: #B00020;" *ngIf="field.config.mandatory">*</span>
                    </span>
                  </ng-template>
                </div>
                    <ng-template [ngIf]="enablePredictiveStopTime">
                     <app-time-picker *ngIf="field.elementKey === 'time'  && stopIndex==0" [showClear]="!field.config.mandatory"
                       [formControl]="stop.get(field.elementKey)" (changeCallback)="timeChangeCallback($event)"
                       [twelveHour]="twelveHour" [dateControl]="dateControl" [ngClass]="{'disableDropdown':disableTimePicker }">
                     </app-time-picker>
                    </ng-template>
                    <ng-template [ngIf]="!enablePredictiveStopTime">
                      <app-time-picker *ngIf="field.elementKey === 'time'" [showClear]="!field.config.mandatory"
                       [formControl]="stop.get(field.elementKey)" (changeCallback)="timeChangeCallback($event)"
                       [twelveHour]="twelveHour" [dateControl]="dateControl" [ngClass]="{'disableDropdown':disableTimePicker }">
                      </app-time-picker>
                    </ng-template>
                    <app-field-generator *ngIf="field.elementKey != 'riders' && field.elementKey !== 'time'"
                      [config]="field.config" [city]="getCityBoundForStop(stopIndex)"
                      [savedLocations]="getSavedLocations(stopIndex)"
                      [showSavedLocationOnly]="stopIndex == 0 ? isStartAirportOnly : (stopIndex == getStops().length - 1 ? isEndAirportOnly : false)"
                      [getLocationLabel]="getLocationLabel" [inputControl]="stop.get(field.elementKey)"
                      [styleApplied]="'booking-trip-location-search'">
                    </app-field-generator>
                    <div class="rider-names" *ngIf="field.elementKey == 'riders'">
                      <div class="rider-list" *ngIf="stop.get('riders')?.value?.length; else selectRider">
                        <ng-container>
                          <span  class="rider mt-6 mr-10 pickupRider" *ngIf="getBoardingNumber(stop.get('riders').controls,'PickUp')>0" >
                            <img class="mr-4 "
                              src="assets/pickupRider.svg" />
                            <span class="fs-12 font-weight-700">
                              {{getBoardingNumber(stop.get('riders').controls,'PickUp')}}
                            </span>
                          </span>


                          <span class="rider mt-6 mr-10 dropRider" *ngIf="getBoardingNumber(stop.get('riders').controls,'Drop')>0" >
                            <img class="mr-4 "
                              src="assets/dropRider.svg" />
                            <span class="fs-12 font-weight-700">
                              {{getBoardingNumber(stop.get('riders').controls,'Drop')}}
                            </span>
                          </span>
                        </ng-container>
                      </div>
                      <ng-template #selectRider> <div class="geoaraea-label fs-12 font-weight-700 mt-24"> Expand to add passeneger</div></ng-template>
                      <div class="rider-error-msg mt-4"
                        *ngIf="stop.get('riders').errors && stop.get('riders').errors.notEmpty">
                        <img src="assets/error-16.svg" alt="" class="mr-4"> Add passengers to continue
                      </div>
                    </div>
                </div>
            </ng-container>
            <app-button *ngIf=" stop.get('riders')" class="collapse-button" (clickCallback)="toggleRidersView(stopIndex)"
            [prefixIconSrc]="!stopRidersEditActive[stopIndex] ? 'assets/Expand.svg':'assets/Collapse.svg' "
            type="textOnly"  matTooltip="View Details" matTooltipClass="booking-table-tooltip"></app-button>
            <div class="stop-controls">
              <!--  <app-button
                    *ngIf="checkVisibility(addStopConfig.config) && (stopIndex < formDetails.get('stops').controls.length - 1) && !editModeControlHide['Add Stop']"
                    (clickCallback)="addStop(stopIndex + 1)"
                    prefixIconSrc="assets/plus-circle-blue.svg"
                    type="primaryText"
                    text="Add Stop"
                  ></app-button> -->
              <!--     <app-button
                    *ngIf="checkVisibility(removeStopConfig.config) && (stopIndex > 0) && (stopIndex < formDetails.get('stops').controls.length - 1)  && !editModeControlHide['Remove Stop']"
                    (clickCallback)="removeStop(stopIndex)"
                    prefixIconSrc="assets/minus-circle-blue.svg"
                    type="primaryText"
                    text="Remove Stop"
                  ></app-button> -->
                  <button mis-button type="none" size="sm" class="remove-stop"
                  *ngIf="checkVisibility(removeStopConfig.config) && (stopIndex > 0) && (stopIndex < formDetails.get('stops').controls.length - 1)  && !editModeControlHide['Remove Stop']"
                  (click)="removeStop(stopIndex)">
                      <span mis-input-icon class="btn-icon"><img src="assets/cancelstop.svg" alt="" style="width: 18px;"/></span>
                    Remove Stop
                   </button> 
              <!-- <div *ngIf="stop && showError(stop)" [title]="formError" class="warning-wrapper"><img src="assets/warning-circle.svg" /></div> -->
            </div>
          </div>
          <div class="rider-list-wrapper"
            *ngIf="((stopIndex !=  formDetails.get('stops').length - 1) && stopRidersEditActive[stopIndex])">
            <table class="traveller-table">
              <thead class="traveller-table-header">
                <tr>
                  <ng-container *ngFor="let field of getRiderConfig(stopIndex)">
                    <th class="column-heading" *ngIf="isTableCellVisible(field)"
                      [ngClass]="{'boarding-column': field.elementKey == 'boardingType'}">{{field.config.displayName}}
                    </th>
                  </ng-container>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let rider of stop.get('riders').controls; let riderIndex = index;">
                  <ng-container *ngFor="let field of getRiderConfig(stopIndex)">
                    <ng-container *ngIf="isTableCellVisible(field)">
                      <td class="editable-cells" *ngIf="field.config.elementType"
                        [ngClass]="{'boarding-column': field.elementKey == 'boardingType'}">
                        <ng-container *ngIf="checkVisibility(field.config, rider)">
                          <ng-container [ngSwitch]="field.elementKey">
                            <app-select *ngSwitchCase="'name'" [getCustomOptionValue]="getRiderValue"
                              [getCustomOptionLabel]="getRiderLabel" [config]="field.config"
                              [type]="formConstants.getElementType(field.config.elementType)"
                              [formControl]="rider.get(field.elementKey)"
                              (changeCallback)="onRiderChange(rider, stopIndex)"
                              [hideOptions]="stop.get('riders').getRawValue()" [options]="userDetails.riders">
                            </app-select>
                            <app-select class="boarding-dropdown" *ngSwitchCase="'boardingType'"
                              [getCustomOptionValue]="getBoardingValue" [getCustomOptionLabel]="getBoardingLabel"
                              [getIconFromValue]="getImageFromValue" [config]="field.config"
                              [type]="formConstants.getElementType(field.config.elementType)"
                              [formControl]="rider.get(field.elementKey)" [hasIcon]="true"
                              (changeCallback)="onRiderChange(rider, stopIndex)" [options]="this.boardingOptions">
                            </app-select>

                            <app-field-generator *ngSwitchDefault [config]="field.config"
                              [inputControl]="rider.get(field.elementKey)">
                            </app-field-generator>
                          </ng-container>
                        </ng-container>
                      </td>
                      <td class="editable-row-static-content" *ngIf="!field.config.elementType">
                        {{rider.get(field.elementKey).value}}
                      </td>
                    </ng-container>
                  </ng-container>
                  <td class="deleteIcon">
                    <button mat-icon-button *ngIf="!editModeControlHide['Remove Rider']"
                      (click)="removeRider(riderIndex, stop)">
                      <mat-icon svgIcon="delete"></mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <button class="btn-font ml-8 mb-16" *ngIf="!editModeControlHide['Add Rider'] && disablebtn(stop.get('riders')?.length) "
              mat-button color="primary" (click)="addRider(stop, stopIndex)">
              <!-- <mat-icon matPrefix>battery_unknown</mat-icon> -->
              Add Passenger
            </button>
            <!-- <app-button *ngIf="!editModeControlHide['Add Rider']" type="primaryText" size="tiny" text="+  Add Rider" (clickCallback)="addRider(stop, stopIndex)"></app-button> -->
          </div>
        </div>
        <div *ngIf=" checkVisibility(addStopConfig.config,formDetails) && stopIndex==formDetails.get('stops').controls.length - 2 " [ngClass]="stopIndex==formDetails.get('stops').controls.length - 1 ? '' : 'add-stop-container'">
          <button mis-button type="none" size="sm" class="add-stop"
            *ngIf="checkVisibility(addStopConfig.config,formDetails) && (stopIndex < formDetails.get('stops').controls.length - 1) && !editModeControlHide['Add Stop']"
            (click)="addStop(stopIndex + 1)">
            <span mis-input-icon class="btn-icon"><img src="/assets/images/add-24.svg" alt="" style="width: 16px;"/></span>
            Add Stop
          </button>
        </div>
      </ng-container>
    </div>
  </ng-template>
  <!-- -----------multiday section  -->

  <div class="stop-list" *ngIf="multidayUI && !dateEditable; else oneday">
    <div class="multiDay1">
      <span class="font-weight-700 fs-14 ">Day-1</span>
      <ng-container *ngFor="let stop of getStops(); let stopIndex = index" >
        <div class="">
          <div class="stop-form mt-24 mb-24 displayFlex">
            <ng-container *ngFor="let field of this.getFieldConfig(stopIndex)">
              <div class="field-column"
                [ngClass]="{'address': field.elementKey === 'address', 'time': field.elementKey === 'time'}"
                *ngIf="checkVisibility(field.config, stop) && field.config.elementType != 'button'">
                <div class="mb-10" *ngIf="field.elementKey != 'riders' && !(field.elementKey=='time' && stopIndex>0)">
                  <span
                    *ngIf=" field.config.displayName=='End Address' || field.config.displayName=='Stop'; else displayName">
                    Address </span>
                  <ng-template #displayName>{{field.config.displayName}}</ng-template>
                </div>
                <app-time-picker *ngIf="field.elementKey === 'time' && stopIndex==0"
                  [showClear]="!field.config.mandatory" [formControl]="stop.get(field.elementKey)"
                  (changeCallback)="timeChangeCallback($event)" [twelveHour]="twelveHour" [dateControl]="dateControl">
                </app-time-picker>
                <app-field-generator *ngIf="field.elementKey != 'riders' && field.elementKey !== 'time'"
                  [config]="field.config" [city]="getCityBoundForStop(stopIndex)"
                  [savedLocations]="getSavedLocations(stopIndex)"
                  [showSavedLocationOnly]="stopIndex == 0 ? isStartAirportOnly : (stopIndex == getStops().length - 1 ? isEndAirportOnly : false)"
                  [getLocationLabel]="getLocationLabel" [inputControl]="stop.get(field.elementKey)"
                  [styleApplied]="'booking-trip-location-search'">
                </app-field-generator>
              </div>
            </ng-container>
            <button [ngStyle]="stopIndex==getStops().length - 1 ? {'right':'28px'} : {'right':'178px'}"
              *ngIf="getStops().length>2 && stopIndex != 0 && stopIndex!=1" mis-button type="none" size="sm"
              class="multiday-remove-stop" (click)="removeStop(stopIndex)">
              <span mis-input-icon class=""><img src="assets/cancelstop.svg" style="width: 18px;"/></span>
              Remove Address
            </button>
            <div class="multi-add-btn">
              <button *ngIf="stopIndex == getStops().length - 1" mis-button type="" size="sm" class="multiday-add-stop" (click)="addStop(stopIndex + 1)">
                <span mis-input-icon class="btn-icon"><img src="/assets/images/add-24.svg" style="width: 16px;" /></span>
                Add Address
              </button>
            </div>

          </div>
        </div>
      </ng-container>
    </div>
    <!-- -----------------day2-3 -->
    <div *ngIf="multiDaysCount.length>0">
      <div *ngFor="let day of multiDaysCount | arraySlice; let dayIndex=index">
        <div class="dayLineSeparator"></div>
        <div class="extraDays">
          <ng-container *ngFor="let address of getMidStops(dayIndex); let stopIndex = index">
            <div *ngIf=" getMidStops(dayIndex).length>0">
              <span *ngIf="stopIndex==0" class="font-weight-700 fs-14 ">Day-{{dayIndex+2}}</span>
              <div class="stop-form  displayFlex">
                <ng-container *ngFor="let field of multiMidDayConfig.elementConfigList">
                  <div class="field-column" [ngClass]="{'address': field.elementKey === 'address'}">
                    <div class="mb-10">
                      <span>{{field.config.displayName}}</span>
                    </div>
                    <app-field-generator [config]="field.config" [city]="getCityBoundForStop(stopIndex)"
                      [getLocationLabel]="getLocationLabel" [inputControl]="address.get(field.elementKey)"
                      [styleApplied]="'booking-trip-location-search'">
                    </app-field-generator>
                  </div>
                </ng-container>
                <div class="multi-add-btn">
                  <button *ngIf="getMidStops(dayIndex).length-1 == stopIndex" mis-button type="" size="sm"
                    class="multiday-add-stop" (click)="addMidStop(stopIndex + 1,dayIndex+2)">
                    <span mis-input-icon class="btn-icon"><img src="/assets/images/add-24.svg" style="width: 16px;"/></span>
                    Add Address
                  </button>
                </div>
                <button mis-button type="none" size="sm" class="multiday-remove-stop"
                  (click)="removeMidStop(stopIndex,dayIndex+2)" style="right:'28px'">
                  <span mis-input-icon class=""><img src="assets/cancelstop.svg" style="width: 18px;" /></span>
                  Remove Address
                </button>
              </div>
            </div>
          </ng-container>
        </div>
     </div>
    </div>


  </div>
  <app-dialog *ngIf="boardingChangeMessage" titleText="Rider information changed" type="alert" [buttonText]="['Okay']"
    (approveCallback)="clearBoardingChangeMessage()">
    {{boardingChangeMessage}}
  </app-dialog>
</div>
<app-dialog *ngIf="showDialog" titleText="Warning" type="alert" [buttonText]="['Okay']"
  (approveCallback)="closeDialog()">
  This rider cannot be removed from this stop just yet.
  This rider is selected as payer for this booking.
  Please add pickup point of this rider in any other stop before removing from here.
</app-dialog>

<app-dialog *ngIf="showDialog1" type="alert" titleText="Warning" [buttonText]="['Okay']"
  (approveCallback)="closeDialog()">
  This stop cannot be removed from the booking. Payer is being picked up from here.
  Please add pickup point of payer in any other stop before removing this stop.
</app-dialog>
<app-toast *ngIf="showHighCapacityPopup" message="Additional cab types are now available to book from." (dismissCallback)="toggleToast()">
